import React from 'react';
import { Box, Paper, Typography, Button, Stack } from '@mui/material';
import Grid from '@mui/material/Grid';
import { FormMode, USysObjects } from '../utils/extensions/constantEx';
import { HomeContext } from '../utils/contexts/homeContext';

export default function BookingFormHeader(props) {
    const { formMode, handleEditClick, handleSaveClick, handleCancelClick, handleDeleteClick } = props;

    const { homeState } = React.useContext(HomeContext);

    return (

        <Paper sx={{ zIndex: '900' }}>
            <Grid
                container
                direction="row"
                justifyContent="space-between"
                alignItems="stretch"
            >
                <Grid size={3}>
                    <Typography variant="h5" sx={{ p: 2 }}>
                        {
                            formMode === FormMode.EditMode ? 'Edit Service Booking' :
                                formMode === FormMode.NewMode ? 'New Service Booking' : 'View Service Booking'
                        }
                    </Typography>
                </Grid>
                <Grid size={9}>
                    <Box sx={{ pr: 1, float: 'right', paddingTop: '14px' }}>
                        <Stack direction="row" spacing={2}>
                            {/* {
                                formMode === FormMode.ViewMode &&
                                <Button variant="contained" color="error" onClick={handleDeleteClick}>Delete</Button>
                            } */}
                            {
                                formMode === FormMode.ViewMode &&
                                homeState.loggedUser.objectRights.find(col => col.object_id === USysObjects.PatientServiceBookings && col.is_edit) &&
                                <Button variant="contained" onClick={handleEditClick}>Edit</Button>
                            }
                            {
                                formMode !== FormMode.ViewMode &&
                                <Button variant="contained" onClick={handleSaveClick}>Save</Button>
                            }
                            <Button variant="outlined" onClick={handleCancelClick}>
                                {formMode === FormMode.ViewMode ? 'Close' : 'Cancel'}
                            </Button>
                        </Stack>

                    </Box>
                </Grid>
            </Grid>
        </Paper>

    );
}
